import { z } from 'zod'
import type { AttachmentRequirement } from '@/features/attachments/components/types/attachment-requirements'
import { MESSAGES_VALIDATE } from '@/shared/constants/messages'

export enum EnumPeriod {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

export enum EnumTypeStates {
  init = 'init',
  process = 'process',
  reject = 'reject',
  rescind = 'rescind',
  inactive = 'inactive',
  end = 'end',
  undefined = 'undefined'
}

export enum EnumTypeNotification {
  AUTHOR = 'author',
  EDITOR = 'editor',
  ADVISOR = 'advisor',
  PRINCIPAL_OWNER = 'principalOwner',
  ALL_OWNERS = 'allOwners',
  CUSTOM = 'custom'
}

export interface IState {
  _id: string
  id: string
  name: string
  description: string
  color: string
  time: number
  interval: EnumPeriod
  // Espejo del API (states/model/state.schema.ts): lista de destinatarios
  notification: EnumTypeNotification[]
  emailsNotification: string[]
  sendSAP: boolean
  type: EnumTypeStates
  active: boolean
  blocked: boolean
  visible: boolean
  attachmentRequirements?: AttachmentRequirement[]
}

export const STATE_SCHEMA = {
  _ID: '_id',
  ID: 'id',
  NAME: 'name',
  DESCRIPTION: 'description',
  COLOR: 'color',
  TIME: 'time',
  INTERVAL: 'interval',
  NOTIFICATION: 'notification',
  EMAILS_NOTIFICATION: 'emailsNotification',
  TYPE: 'type',
  ACTIVE: 'active',
  SEND_SAP: 'sendSAP'
} as const

export const VALIDATION_STATE_SCHEMA = z.object({
  [STATE_SCHEMA.NAME]: z.string().min(1, MESSAGES_VALIDATE.REQUIRED),
  [STATE_SCHEMA.DESCRIPTION]: z.string(),
  [STATE_SCHEMA.COLOR]: z.string(),
  [STATE_SCHEMA.TIME]: z.number().min(1, MESSAGES_VALIDATE.MIN(1)),
  [STATE_SCHEMA.INTERVAL]: z.string().min(1, MESSAGES_VALIDATE.REQUIRED),
  [STATE_SCHEMA.NOTIFICATION]: z.array(z.string()),
  [STATE_SCHEMA.EMAILS_NOTIFICATION]: z.array(z.string().email()).min(1, MESSAGES_VALIDATE.EMAIL),
  [STATE_SCHEMA.ACTIVE]: z.boolean(),
  [STATE_SCHEMA.SEND_SAP]: z.boolean()
})
